import Vue from 'vue';

document.getElementById('menu-item-newsletters').classList.add('current-menu-item')

import NewslettersApp from '../Scripts/Newsletters/newslettersApp.vue'

new Vue({
    el:"#app",
    components: {
        NewslettersApp
    },
    data() {
        return {

        }
    },
    template: '<newsletters-app></newsletters-app>'
})